import { CSSObject, keyframes } from '@emotion/react'
import { ZIndex } from '@opallabs/gem'

export const readMoreOverlay = ({
  isExpanded,
  isOverflowed,
}: {
  isExpanded: boolean
  isOverflowed: boolean
}): CSSObject => {
  const fadeIn = keyframes({
    '0%': {
      opacity: 0,
    },
    '50%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  })

  if (isOverflowed) {
    const button: CSSObject = {
      position: 'absolute',
      insetBlockEnd: '28px',
      insetInlineStart: '24px',
      cursor: 'pointer',
      animation: isExpanded ? `0.3s ease-in-out ${fadeIn}` : '',
      pointerEvents: 'auto',
    }

    const notExpanded: CSSObject = {
      '& ~ .content-overflowed:not(.has-focus)': {
        maxBlockSize: '510px',
        overflow: 'hidden',
      },
      cursor: 'pointer',
      position: 'absolute',
      insetBlockStart: 0,
      insetBlockEnd: 0,
      insetInlineStart: 0,
      insetInlineEnd: 0,
      background: 'linear-gradient(-180deg, transparent 0%, #fff 100%)',
      borderRadius: 12,
    }

    const expanded: CSSObject = {
      '& ~ .content-overflowed:not(.has-focus)': {
        paddingBlockEnd: '44px',
      },
    }

    return {
      zIndex: ZIndex.Element.Level1,

      button,
      ...(isExpanded ? expanded : notExpanded),
    }
  }

  return {
    display: 'none',
  }
}
